import { usePostDocumentNotes } from 'entities/document/api';
import { useTranslation } from 'react-i18next';
import { useShowNotification } from 'shared/hooks/notification/use-show-notification';

export const useUpdateNote = (documentId?: number) => {
  const { mutateAsync } = usePostDocumentNotes(documentId);
  const showNotification = useShowNotification();
  const { t } = useTranslation('document');

  const updateNote = async (notes: string) => {
    try {
      await mutateAsync(notes);
      showNotification({
        variant: 'success',
        message: t('notification.note.edit.success'),
      });
    } catch (_e) {
      showNotification({
        variant: 'error',
        message: t('notification.note.edit.error'),
      });
    }
  };

  return { updateNote };
};
